import { BINDING_STATUS_FILTER_DETAILS, LAST_LOGON_FILTER_DETAILS, MODE_FILTER_DETAILS } from "./consts";
import { HostnameFilterValue, LocalAccountsFilters } from "../../../../types/LocalAccountsFilters";
import { FilterDetails, FilterOption, SearchableFilterDetails } from "../../../../types/filters";
import { Dispatch, SetStateAction } from "react";

const HOSTNAME_FILTER_ID = 'hostname';

const mapHostnameOptions = (hostnames: HostnameFilterValue[]): FilterOption<HostnameFilterValue>[] => {
    return hostnames.map((hostname) => ({ value: hostname, label: hostname }));
};

const getHostnameBaseFilters = (
    hostnames: HostnameFilterValue[],
    hostnamesSearchHandler: (searchTerm: string) => void
): FilterDetails<LocalAccountsFilters> => {
    const hostnameOptions = mapHostnameOptions(hostnames);

    return {
        id: HOSTNAME_FILTER_ID,
        label: 'Device name',
        multiple: true,
        searchable: true,
        searchPlaceholder: 'Search by name',
        options: hostnameOptions,
        searchHandler: hostnamesSearchHandler,
        disableSelectAll: true
    };
};

export const getLocalAccountsTableBaseFilters = (params: {
    hostnames: HostnameFilterValue[];
    hostnamesSearchHandler: (searchTerm: string) => void;
}): FilterDetails<LocalAccountsFilters>[] => {
    const { hostnames, hostnamesSearchHandler } = params;
    const hostnameBaseFilterDetails: FilterDetails<LocalAccountsFilters> = getHostnameBaseFilters(hostnames, hostnamesSearchHandler);

    const baseFilters = [
        LAST_LOGON_FILTER_DETAILS,
        BINDING_STATUS_FILTER_DETAILS,
        hostnameBaseFilterDetails,
        MODE_FILTER_DETAILS
    ];

    return baseFilters;
};

export const updateHostnameOptions = (
    hostnames: HostnameFilterValue[],
    setFiltersDetails: Dispatch<SetStateAction<FilterDetails<LocalAccountsFilters>[]>>
) => {
    setFiltersDetails((prevFiltersDetails) => {
        return prevFiltersDetails.map((filterDetails) => {
            if (filterDetails.id === HOSTNAME_FILTER_ID) {
                const searchableFilterDetails = filterDetails as SearchableFilterDetails<LocalAccountsFilters>;
                if (!searchableFilterDetails.searchTerm || searchableFilterDetails.searchTerm === '') {
                    return { ...filterDetails, options: [
                        ...(searchableFilterDetails.selectedOptions || []),
                        ...mapHostnameOptions(hostnames.filter((hostname) => !searchableFilterDetails.selectedItems?.includes(hostname)))
                    ] };
                }
                return { ...filterDetails, options: mapHostnameOptions(sortHostnames(hostnames, searchableFilterDetails.selectedItems)) };
            }
            return filterDetails;
        });
    });
}

const sortHostnames = (hostnames: HostnameFilterValue[], selectedItems?: HostnameFilterValue[]): HostnameFilterValue[] => {
    return hostnames.sort((a, b) => {
        if (selectedItems?.includes(a)) {
            return -1;
        } else if (selectedItems?.includes(b)) {
            return 1;
        }
        return 0;
    });
}
